<template>
  <b-card :class="['sales-progress-card', 'border-0', 'shadow-sm', cardBgClass, { 'cursor-pointer': clickable }]" no-body @click="handleClick">
    <b-card-body>
      <div class="progress-card-title-row">
        <h6 class="card-title text-white mb-0">{{ title }}</h6>
        <WidgetInfoButton
          v-if="infoText"
          :target-id="infoTargetId"
          :title="title"
          :logic="infoText"
        />
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <span class="display-6 text-white">{{ value }}</span>
        <i v-if="progressPercentage !== null" :class="progressIconClass" class="bi text-white"></i>
      </div>
      <div class="small mt-1" v-if="progressPercentage !== null">
        <span :class="progressTextClass">{{ formattedProgress }}%</span>
        <span class="text-white-50"> achieved</span>
      </div>
      <div class="small mt-1 text-white-50" v-if="subtitle">
        {{ subtitle }}
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody } from 'bootstrap-vue';
import WidgetInfoButton from '@/components/dashboard/WidgetInfoButton.vue';

export default {
  name: 'SalesProgressCard',
  components: {
    BCard,
    BCardBody,
    WidgetInfoButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    progressPercentage: {
      type: [Number, null],
      default: null,
    },
    color: {
      type: String,
      default: 'primary',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    infoText: {
      type: String,
      default: '',
    },
  },
  computed: {
    infoTargetId() {
      const normalized = String(this.title || 'sales-card')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      return `sales-card-info-${normalized}`;
    },
    cardBgClass() {
      const map = {
        'blue darken-1': 'bg-primary',
        'blue darken-2': 'bg-primary',
        'green darken-1': 'bg-success',
        'green darken-2': 'bg-success',
        'orange darken-1': 'bg-warning',
        'orange darken-2': 'bg-warning',
        'purple darken-1': 'bg-info',
        'purple darken-2': 'bg-info',
        'red darken-1': 'bg-danger',
        'red darken-2': 'bg-danger',
        'red darken-4': 'bg-danger',
        'amber darken-1': 'bg-warning',
        'amber darken-2': 'bg-warning',
        'blue-grey darken-1': 'bg-secondary',
        'grey darken-3': 'bg-dark',
        'teal darken-1': 'bg-info',
        'teal darken-2': 'bg-info',
        'cyan darken-1': 'bg-info',
        'cyan darken-2': 'bg-info',
        'light-green darken-1': 'bg-success',
        'light-green darken-2': 'bg-success',
        'light-blue darken-1': 'bg-info',
        'light-blue darken-2': 'bg-info',
        'indigo darken-1': 'bg-primary',
        'deep-orange darken-1': 'bg-danger',
        'deep-orange darken-2': 'bg-danger',
        primary: 'bg-primary',
        info: 'bg-info',
        warning: 'bg-warning',
        danger: 'bg-danger',
        success: 'bg-success',
        secondary: 'bg-secondary',
        dark: 'bg-dark',
      };
      return map[this.color] || 'bg-primary';
    },
    progressIconClass() {
      if (this.progressPercentage === null) return '';
      return this.progressPercentage >= 0 ? 'bi-graph-up-arrow' : 'bi-graph-down-arrow';
    },
    progressTextClass() {
      if (this.progressPercentage === null) return '';
      return this.progressPercentage >= 0 ? 'text-success' : 'text-danger';
    },
    formattedProgress() {
      if (this.progressPercentage === null) return Math.abs(this.progressPercentage).toFixed(2);
    },
  },
  methods: {
    handleClick() {
      if (this.clickable) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style scoped>
.sales-progress-card {
  margin: 10px;
}

.progress-card-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
</style>
